import { globalGrafanaReporter } from '../../events/grafana';
import { globalMixpanelReporter } from '../../events/mixpanel';
import { globalBigQueryReporter } from '../../events/bigQuery';

export const reportIdentificationCompletion = () => {
    globalGrafanaReporter.count('identification.%{platform}.completed');
    globalMixpanelReporter.send('Identification - Completed');
    globalBigQueryReporter.send('identification.completed');
};
